import { authClient } from './amplifyClient';
import {
    createArchivedDiscrepancy as createArchivedDiscrepancyMutation,
    deleteDiscrepancy as deleteDiscrepancyMutation,
} from '../graphql/mutations';
import type { CreateArchivedDiscrepancyInput, Discrepancy } from '../types/schema';
import type { CreateArchivedDiscrepancyInput as GqlCreateArchivedDiscrepancyInput } from '../graphql/API';

/**
 * Moves a live discrepancy into ArchivedDiscrepancy and deletes the original.
 * Used when an issue is marked resolved (and any other explicit archive flows).
 *
 * Preserves the original `id` on the archived row so `/issue/:id` keeps working
 * after resolve (IssueDetail falls back to getArchivedDiscrepancy).
 */
export const archiveDiscrepancyRecord = async (
    item: Discrepancy | CreateArchivedDiscrepancyInput,
): Promise<void> => {
    const sourceId = item.id;
    if (!sourceId) {
        throw new Error('Cannot archive a discrepancy without an id.');
    }

    const archivedInput = {
        ...(item as Discrepancy),
        id: sourceId,
        __typename: undefined,
        owner: undefined,
        archivedDate: new Date().toISOString(),
    } as GqlCreateArchivedDiscrepancyInput;

    await authClient.graphql({
        query: createArchivedDiscrepancyMutation,
        variables: {
            input: archivedInput,
        },
    });

    await authClient.graphql({
        query: deleteDiscrepancyMutation,
        variables: {
            input: {
                id: sourceId,
            },
        },
    });
};
